import React, { useState, useEffect, useRef, Fragment } from "react"
import { fireStore, storageRef } from "../firebase/firebase"
import { useAuth } from "../firebase/useAuth"
import {	Modal,	TextareaAutosize,	TextField,	Checkbox,	withStyles } from "@material-ui/core"
import {	Delete,	GetApp,	ArrowForwardIos,	ArrowBackIos, FileCopy, AddPhotoAlternate, VolumeUp, VolumeOff } from "@material-ui/icons"
import downloadAndZip from "../helpers/zipSaver"
import { useStore } from "../context/context"
import { motion } from "framer-motion"
import ImageShowcaseModal from "./ImageShowCase"
import { Loading } from "../helpers/components"
import { SortableContainer, SortableElement } from "react-sortable-hoc"
import arrayMove from "array-move"
import { unfocus } from "../helpers/functions"
import noImg from "../assets/no-img.png"
import ReactPlayer from "react-player"
import moment from "moment"


const GreenCheckbox = withStyles({
	root: { color: "#5bc94a" },
	checked: {},
})(props => <Checkbox color="default" checked={props.checked} onChange={props.onChange} {...props} />)


export default function EditPost(props) {
	const { open, onClose, post, images, setImages, done, setDone, description, setDescription, hashtags, setHashtags, plannedFor, setPlannedFor } = props
	const [currentUser] = useAuth()
	const { dispatch } = useStore()

	const userRef = fireStore.collection("users").doc(currentUser?.uid)
	const copyHastagsToClipboardRef = useRef(null)
	const descriptionInputRef = useRef(null)

	const [posts, setPosts] = useState([])
	const [hashtagInputValue, setHashtagInputValue] = useState("")
	const [imagesAreLoading, setImagesAreLoading] = useState(false)
	const [imageLoadingProgress, setImageLoadingProgress] = useState(0)
	const [imageSelected, setImageSelected] = useState(0)
  const [showImageShowcase, setShowImageShowcase] = useState(false)
  const [videoIsMuted, setVideoIsMuted] = useState(true)

  const VolumeButton = videoIsMuted ? VolumeOff : VolumeUp

	const SortableImageItem = SortableElement(({ value, i }) => (
		<li>
      {value.type === "video" ? (
        <ReactPlayer 
          className="imagePreview"
          url={value.src || noImg}
          alt={value.src || noImg}
          playing={false}
          onClick={() => setImageSelected(i)}
        />
      ) : (
        <img
          className="imagePreview"
          src={value.src || noImg}
          alt={value.src || noImg}
          onClick={() => setImageSelected(i)}
        />
      )}
		</li>
	))
	const SortableImageList = SortableContainer(({ items, row }) => (
    <ul style={{
      width: "fit-content", 
      listStyle: "none", 
      display: "flex",
      flexFlow: "wrap", 
      flexDirection: row ? "row" : "column" 
    }}>
      {items.map((value, i) => (
        <SortableImageItem key={`item-${value?.src}`} index={i} i={i} value={value} />
      ))}
    </ul>
  ))
	const onSortEnd = ({ oldIndex, newIndex }) => setImages(arrayMove(images, oldIndex, newIndex))


	useEffect(() => { if (currentUser) setPosts(currentUser.posts) }, [currentUser])
	useEffect(() => { if (currentUser) setPosts(currentUser.posts) }, [])

	useEffect(() => {
		setDescription(post?.description)
    setHashtags(post?.hashtags)
    setPlannedFor(post?.plannedFor)
	}, [])

	const [severalImages, setSeveralImages] = useState(images.length > 1)
	useEffect(() => images.length > 1 ? setSeveralImages(true) : setSeveralImages(false), [images])

	const uploadImage = async e => {
		setImagesAreLoading(true)
		const promises = []
    const files = e.target.files
		Array.from(files).forEach(file => {
      const fileType = file.type.split("/")[0]
			const imageRef = storageRef.child(
				`${currentUser?.displayName}/${file.name}`
			)
			const promise = imageRef.put(file)
      promises.push(promise)
      promise.on("state_changed", snap => {
        const progressPercent = parseInt(snap.bytesTransferred / snap.totalBytes * 100)
        setImageLoadingProgress(progressPercent)
      })
			promise.then(() => {
				imageRef.getDownloadURL().then(newImageUrl => {
					setImages(prevState => [...prevState, {
            src: newImageUrl,
            type: fileType
          }])
				})
      }).catch(err => console.log({errorInUpload: err}))
      Promise.all(promises).then(() => setImagesAreLoading(false))
    })
	}

	const handleDoneChange = () => {
		const updatedPosts = posts.map(p =>
			p.post_id === post.post_id ? { ...p, done: !done } : p
		)
		userRef.update({ posts: updatedPosts })
	}

	const downloadImages = () => {
    if(images.length > 0) {
      dispatch({ type: "SET_NOTIFICATION", payload: {
        type: "info",
        title: "Téléchargement...",
      }})
      downloadAndZip(images.map(image => image.src))
    } else {
      dispatch({ type: "SET_NOTIFICATION", payload: {
        type: "warning",
        title: "Il n'y a pas d'images/vidéos à télécharger",
      }})
    }
  }
  
  const handleDateChange = e => setPlannedFor(e.target.value)

	const handleDescriptionChange = e => setDescription(e.target.value)

	const handleHashtagsSubmit = e => {
		e.preventDefault()
		if (hashtagInputValue && !hashtags.some(ht => ht === hashtagInputValue)) {
      if(hashtagInputValue.includes(" ") && hashtagInputValue.includes("#")) {
        console.log("hey")
        setHashtags(ps => [...ps, ...hashtagInputValue.split(" ").filter(tag => tag.length > 0)])
      } else {
        setHashtags(ps => [...ps, `#${hashtagInputValue}`])
      }
			setHashtagInputValue("")
		}
	}

	const removeHashtag = (_, hashtag) => {
		setHashtags(ps => ps.filter(ht => ht !== hashtag))
	}

	const copyHashtagsToClipboard = () => {
    if(hashtags.length === 0) return
		const hashtagsTextValue = hashtags.reduce(
			(old, current) => `${old} ${current}`,
			""
		)
		copyHastagsToClipboardRef.current.value = hashtagsTextValue
		copyHastagsToClipboardRef.current.focus()
		copyHastagsToClipboardRef.current.select()
		document.execCommand("copy")
		dispatch({
			type: "SET_NOTIFICATION",
			payload: "Hashtags copiés dans le presse papier",
		})
  }
  
  const copyDescriptionToClipboard = () => {
    if(description === "") return
    descriptionInputRef.current.focus()
    descriptionInputRef.current.select()
    document.execCommand("copy")
    unfocus()
    dispatch({ type: "SET_NOTIFICATION", payload: "Description copiée dans le presse papier" })
  }

	const savePostChanges = () => {
		userRef.update({ posts: posts.map(p => p.post_id === post.post_id ? {
        ...p,
        images: images,
        description: description,
        hashtags: hashtags,
        plannedFor: plannedFor
      } : p)
    }).then(() => {
      dispatch({ type: "SET_NOTIFICATION", payload: "Le post a été sauvegardé !" })
      onClose()
    })
	}

	const clearPost = () => {
    const userIsSure = confirm("Êtes vous sûre de vouloir effacer ce post ?")
    if(!userIsSure) return
		setImages([])
		setHashtagInputValue("")
		setDescription("")
		setHashtags([])
		userRef.update({ 
      posts: posts.filter(p => p.post_id !== post.post_id)
    }).then(() => { 
      dispatch({
        type: "SET_NOTIFICATION",
        payload: { type: "warning", title: "Le post a été effacé !" },
      })
      onClose()
    })
	}

	return (
		<Modal open={open} onClose={onClose} className="editPost">
			<motion.div
				className="modalContent"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
			>
				<div className="row">
					<div className="col imageSection">
						<ImageShowcaseModal
							open={showImageShowcase}
							onClose={() => setShowImageShowcase(false)}
							images={images}
							imageSelected={imageSelected}
							setImageSelected={setImageSelected}
							severalImages={severalImages}
						/>
						<div className="imgContainer">
							{severalImages && (
								<ArrowBackIos
									className="imgArrow backward"
									onClick={() =>
										setImageSelected(ps =>
											ps === 0 ? images.length - 1 : ps - 1
										)
									}
								/>
							)}
              {images.length > 0 && (
                <button className="deleteImages imageBtn" onClick={() => setImages([])}><Delete /></button>
              )}
              {images[imageSelected]?.type === "video" ? (
                <>
                  <ReactPlayer 
                    url={images[imageSelected]?.src}
                    className="mainImg"
                    playing loop
                    muted={videoIsMuted}
                    onClick={() => images.length > 0 && setShowImageShowcase(true)}
                  />
                  <button className="muteBtn imageBtn" onClick={() => setVideoIsMuted(ps => !ps)}>
                    <VolumeButton />
                  </button>
                </>
              ) : (
                <img
                  src={images.length > 0 ? images[imageSelected]?.src : noImg}
                  alt="main image"
                  className="mainImg"
                  onClick={() => images.length > 0 && setShowImageShowcase(true)}
                />
              )}
							{imagesAreLoading && (
								<div className="imagesAreLoadingOverlay">
									<Loading />
                  <span className="progressNumber">{imageLoadingProgress}%</span>
								</div>
							)}
							{severalImages && (
								<ArrowForwardIos
									className="imgArrow forward"
									onClick={() =>
										setImageSelected(ps =>
											ps === images.length - 1 ? 0 : ps + 1
										)
									}
								/>
							)}
						</div>
						<div className="imagesPreview">
							<SortableImageList items={images} onSortEnd={onSortEnd} axis="x" distance={3} row />
						</div>
					</div>
					<div className="col editSection">
						<h2 className="editTitle">
							<span className="title">Editer ce post</span>
							<span className="actions">
								<GreenCheckbox checked={done} onChange={handleDoneChange} />
								<div
									className={`dowloadPostImagesBtn ${
										images.length > 0 && "active"
									}`}
									onClick={downloadImages}
								>
									<GetApp />
								</div>
								<Delete onClick={clearPost} className="clearPostBtn" />
							</span>
						</h2>
            <div className="fileDateRow">
              <input
                type="file"
                id="fileInput"
                className="fileUpload"
                onChange={uploadImage}
                multiple
              />
              <label htmlFor="fileInput" className="fileInputLabel">
                <AddPhotoAlternate /> &nbsp; Choisir des fichiers
              </label>
              <input 
                type="datetime-local" 
                className="plannedForBtn" 
                value={plannedFor}
                onChange={handleDateChange}
              />
            </div>
            <div style={{ position: "relative" }}>
              <TextareaAutosize
                placeholder="Post description"
                rowsMin={5}
                className="instaDescriptionInput"
                value={description}
                onChange={handleDescriptionChange}
                ref={descriptionInputRef}
              />
              <span title="Copy to clipboard">
                <FileCopy className="copyBtn" onClick={copyDescriptionToClipboard} />
              </span>
            </div>
						<input
							type="text"
							ref={copyHastagsToClipboardRef}
							style={{ opacity: 0, pointerEvents: "none" }}
						/>
						<form className="hashtagsInputContainer" onSubmit={handleHashtagsSubmit}>
							<TextField
								placeholder="Hashtags (Press Enter to add)"
								className="hashtagsInput"
								value={hashtagInputValue}
								onChange={e => setHashtagInputValue(e.target.value)}
							/>
							<div
								className="copyHashtagsBtn clipboardBtn"
                onClick={copyHashtagsToClipboard}
                title="Copy to clipboard"
							>
								<FileCopy className="icon" />
							</div>
						</form>
						<div className="hashtags">
							{hashtags?.map((hashtag, i) => (
								<div
									className="hashtag"
									key={i}
									onClick={e => removeHashtag(e, hashtag)}
								>
									{hashtag}
								</div>
							))}
						</div>
					</div>
        </div>
        <button className="saveBtn btn" onClick={savePostChanges}>
          Sauvegarder
        </button>
			</motion.div>
		</Modal>
	)
}
